/* =====================================================================
   Tea Length — theme.js
   Encapsulated, vanilla, no dependencies. Modules below are independent.
   ===================================================================== */

(() => {
  'use strict';

  document.documentElement.classList.replace('no-js', 'js');

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => {
    const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt, maximumFractionDigits: 0 }).format(cents / 100);
    } catch {
      return '₹' + Math.round(cents / 100).toLocaleString();
    }
  };

  const toast = (msg) => {
    const t = $('#QuickToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-shown');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-shown'), 2200);
  };

  /* -------------------------------------------------------------------
     Sticky header state
  ------------------------------------------------------------------- */
  (() => {
    const h = $('.header'); if (!h) return;
    if (h.dataset.sticky === 'false') return;
    let last = 0, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      h.dataset.state = y > 40 ? 'scrolled' : '';
      last = y; ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();
  })();

  /* -------------------------------------------------------------------
     Drawer system: open/close any drawer
  ------------------------------------------------------------------- */
  const Drawer = {
    open(el) {
      if (!el) return;
      el.hidden = false;
      requestAnimationFrame(() => el.setAttribute('data-open', ''));
      document.body.style.overflow = 'hidden';
      const focusable = el.querySelector('[data-close], a, button, input');
      focusable && focusable.focus({ preventScroll: true });
      document.addEventListener('keydown', this._esc = (e) => { if (e.key === 'Escape') Drawer.close(el); });
    },
    close(el) {
      if (!el) return;
      el.removeAttribute('data-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._esc);
      setTimeout(() => { el.hidden = true; }, 480);
    }
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-action]');
    if (opener) {
      const a = opener.dataset.action;
      if (a === 'open-cart') {
        e.preventDefault();
        const cart = $('#DrawerCart');
        if (cart) Drawer.open(cart);
        else window.location.href = '/cart';
      }
      if (a === 'open-drawer-nav') { e.preventDefault(); Drawer.open($('#DrawerNav')); }
      if (a === 'open-search') { e.preventDefault(); Drawer.open($('#DrawerSearch')); setTimeout(() => $('#HeaderSearch')?.focus(), 100); }
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      const drawer = closer.closest('.drawer');
      if (drawer) { e.preventDefault(); Drawer.close(drawer); }
    }
  });

  /* -------------------------------------------------------------------
     Marquee speed setter
  ------------------------------------------------------------------- */
  $$('[data-marquee-speed]').forEach((el) => {
    const s = parseInt(el.dataset.marqueeSpeed, 10);
    if (!isNaN(s)) el.style.animationDuration = s + 's';
  });

  /* -------------------------------------------------------------------
     Reveal animations on scroll
  ------------------------------------------------------------------- */
  (() => {
    if (reduced) { $$('.reveal').forEach(el => el.classList.add('is-in')); return; }
    const targets = $$('.reveal');
    if (!targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(el => el.classList.add('is-in'));
      return;
    }
    targets.forEach((el) => {
      const d = el.dataset.revealDelay;
      if (d) el.style.setProperty('--d', d);
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    targets.forEach(t => io.observe(t));
  })();

  /* -------------------------------------------------------------------
     Lookbook subtle parallax
  ------------------------------------------------------------------- */
  (() => {
    if (reduced) return;
    const tiles = $$('[data-parallax="true"] .lb__img');
    if (!tiles.length) return;
    const tick = () => {
      tiles.forEach((img) => {
        const r = img.getBoundingClientRect();
        const vh = window.innerHeight;
        const y = ((r.top + r.height / 2) - vh / 2) / vh;
        img.style.transform = `scale(1.08) translate3d(0, ${(-y * 16).toFixed(2)}px, 0)`;
      });
    };
    window.addEventListener('scroll', () => requestAnimationFrame(tick), { passive: true });
    tick();
  })();

  /* -------------------------------------------------------------------
     Rail (featured collection) navigation
  ------------------------------------------------------------------- */
  $$('[data-rail]').forEach((rail) => {
    const track = rail.querySelector('[data-rail-track]');
    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    const step = () => {
      const width = track.querySelector('[data-rail-slide]')?.getBoundingClientRect().width || 320;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return width + gap;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* -------------------------------------------------------------------
     Instagram Reels: muted autoplay when visible in the rail
  ------------------------------------------------------------------- */
  (() => {
    const reelCards = $$('[data-reel-card]');
    if (!reelCards.length) return;

    const hydrateReel = (video) => {
      let changed = false;
      if (video.dataset.src && !video.getAttribute('src')) {
        video.src = video.dataset.src;
        changed = true;
      }
      $$('source[data-src]', video).forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        changed = true;
      });
      if (changed) video.load();
    };

    const playReel = (video) => {
      video.muted = true;
      hydrateReel(video);
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => { /* autoplay blocked */ });
      }
    };

    const pauseReel = (video) => {
      try { video.pause(); } catch (_) { /* no-op */ }
    };

    const reelObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector('.reels__video');
        if (!video) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          playReel(video);
        } else {
          pauseReel(video);
        }
      });
    }, { threshold: [0, 0.5, 0.75], rootMargin: '0px 0px -8% 0px' });

    reelCards.forEach((card) => {
      const video = card.querySelector('.reels__video');
      if (!video) return;
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      reelObserver.observe(card);
    });
  })();

  /* -------------------------------------------------------------------
     Quantity controls
  ------------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = wrap?.querySelector('.qty__input');
    if (!input) return;
    const delta = parseInt(btn.dataset.qtyChange, 10);
    const min = parseInt(input.min || '0', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + delta));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty__input');
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    input.value = Math.min(max, Math.max(min, parseInt(input.value, 10) || min));
  });

  /* -------------------------------------------------------------------
     Product page: variant picker + gallery + tabs
  ------------------------------------------------------------------- */
  (() => {
    const pdp = $('.pdp'); if (!pdp) return;

    /* One-at-a-time horizontal product gallery */
    const gallery = $('[data-gallery]', pdp);
    const mediaStack = gallery && $('[data-media-stack]', gallery);
    const slides = gallery ? $$('.pdp__media', gallery) : [];
    const thumbs = $$('[data-thumb]', pdp);
    const currentCount = gallery && $('[data-gallery-current]', gallery);
    const totalCount = gallery && $('[data-gallery-total]', gallery);
    const galleryControls = gallery && $('.pdp__gallery-controls', gallery);
    const lightbox = gallery && $('[data-product-lightbox]', gallery);
    const lightboxImage = lightbox && $('[data-lightbox-image]', lightbox);
    const lightboxCount = lightbox && $('[data-lightbox-count]', lightbox);
    const lightboxTriggers = gallery ? $$('[data-lightbox-trigger]', gallery) : [];
    let activeSlide = 0;
    let lightboxReturnFocus = null;

    const visibleIndexes = () => slides
      .map((slide, index) => slide.hidden ? -1 : index)
      .filter((index) => index >= 0);

    const showSlide = (index) => {
      if (!slides.length) return;
      const visible = visibleIndexes();
      if (!visible.length) return;
      activeSlide = visible.includes(index) ? index : visible[0];

      slides.forEach((slide, i) => {
        const isActive = !slide.hidden && i === activeSlide;
        slide.classList.toggle('is-active', isActive);
        slide.classList.toggle('is-before', i < activeSlide);
        slide.setAttribute('aria-hidden', String(!isActive));
        if (slide.hasAttribute('data-lightbox-trigger')) slide.tabIndex = isActive ? 0 : -1;
        if (!isActive) slide.querySelector('video')?.pause();
      });

      thumbs.forEach((thumb, i) => {
        const isActive = i === activeSlide;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });

      if (currentCount) currentCount.textContent = String(visible.indexOf(activeSlide) + 1);
      if (totalCount) totalCount.textContent = String(visible.length);
      thumbs[activeSlide]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    const moveSlide = (direction) => {
      const visible = visibleIndexes();
      if (!visible.length) return;
      const position = visible.indexOf(activeSlide);
      const nextPosition = (position + direction + visible.length) % visible.length;
      showSlide(visible[nextPosition]);
    };

    const handleize = (value) => String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

    const filterGalleryByColour = (colour) => {
      const colourKey = handleize(colour);
      const hasColourImages = colourKey && slides.some((slide) => slide.dataset.mediaColour === colourKey);

      slides.forEach((slide, i) => {
        const isVisible = !hasColourImages || slide.dataset.mediaColour === colourKey;
        slide.hidden = !isVisible;
        if (thumbs[i]) thumbs[i].hidden = !isVisible;
      });

      const visible = visibleIndexes();
      if (galleryControls) galleryControls.hidden = visible.length <= 1;
      showSlide(visible[0] || 0);
    };

    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const id = t.dataset.thumb;
        const index = slides.findIndex((slide) => slide.dataset.mediaId === id);
        if (index >= 0) showSlide(index);
      });
    });

    const lightboxIndexes = () => visibleIndexes()
      .filter((index) => slides[index].hasAttribute('data-lightbox-trigger'));

    const updateLightbox = () => {
      if (!lightboxImage) return;
      const indexes = lightboxIndexes();
      const position = indexes.indexOf(activeSlide);
      if (position < 0) return;
      const slide = slides[activeSlide];
      const sourceImage = $('img', slide);
      lightboxImage.src = slide.dataset.lightboxSrc || sourceImage?.currentSrc || sourceImage?.src || '';
      lightboxImage.alt = sourceImage?.alt || '';
      if (lightboxCount) lightboxCount.textContent = `${position + 1} / ${indexes.length}`;
      $$('[data-lightbox-prev], [data-lightbox-next]', lightbox).forEach((button) => {
        button.hidden = indexes.length <= 1;
      });
    };

    const openLightbox = (slide) => {
      const index = slides.indexOf(slide);
      if (index < 0 || slide.hidden) return;
      showSlide(index);
      updateLightbox();
      lightboxReturnFocus = slide;
      lightbox?.showModal();
    };

    const moveLightbox = (direction) => {
      const indexes = lightboxIndexes();
      if (!indexes.length) return;
      const position = indexes.indexOf(activeSlide);
      showSlide(indexes[(position + direction + indexes.length) % indexes.length]);
      updateLightbox();
    };

    lightboxTriggers.forEach((slide) => {
      slide.addEventListener('click', () => openLightbox(slide));
      slide.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        openLightbox(slide);
      });
    });
    $('[data-lightbox-close]', lightbox)?.addEventListener('click', () => lightbox.close());
    $('[data-lightbox-prev]', lightbox)?.addEventListener('click', () => moveLightbox(-1));
    $('[data-lightbox-next]', lightbox)?.addEventListener('click', () => moveLightbox(1));
    lightbox?.addEventListener('click', (e) => {
      if (e.target === lightbox) lightbox.close();
    });
    lightbox?.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      e.stopPropagation();
      moveLightbox(e.key === 'ArrowLeft' ? -1 : 1);
    });
    let lightboxTouchStartX = 0;
    lightbox?.addEventListener('touchstart', (e) => {
      lightboxTouchStartX = e.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    lightbox?.addEventListener('touchend', (e) => {
      const distance = (e.changedTouches[0]?.clientX || 0) - lightboxTouchStartX;
      if (Math.abs(distance) >= 50) moveLightbox(distance < 0 ? 1 : -1);
    }, { passive: true });
    lightbox?.addEventListener('close', () => lightboxReturnFocus?.focus());

    if (gallery && slides.length > 1) {
      gallery.setAttribute('tabindex', '0');
      $('[data-gallery-prev]', gallery)?.addEventListener('click', () => moveSlide(-1));
      $('[data-gallery-next]', gallery)?.addEventListener('click', () => moveSlide(1));
      gallery.addEventListener('keydown', (e) => {
        if (lightbox?.open) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          moveSlide(-1);
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          moveSlide(1);
        }
      });

      let touchStartX = 0;
      mediaStack?.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0]?.clientX || 0;
      }, { passive: true });
      mediaStack?.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0]?.clientX || 0;
        const distance = touchEndX - touchStartX;
        if (Math.abs(distance) < 50) return;
        moveSlide(distance < 0 ? 1 : -1);
      }, { passive: true });
    }
    if (mediaStack) showSlide(0);

    /* Tabs */
    const tabHeads = $$('.pdp__tab-head', pdp);
    tabHeads.forEach((h) => {
      h.addEventListener('click', () => {
        const id = h.dataset.tab;
        tabHeads.forEach((x) => {
          x.classList.toggle('is-active', x === h);
          x.setAttribute('aria-selected', x === h);
        });
        $$('.pdp__tab-body', pdp).forEach((b) => {
          b.classList.toggle('is-hidden', b.dataset.tabBody !== id);
        });
      });
    });

    /* Variant selection */
    const form = $('[data-pdp-form]', pdp);
    if (!form) return;
    const select = form.querySelector('[data-variant-id]');
    const optionInputs = $$('[data-option-input]', form);

    const updateFromSelections = () => {
      const opts = [null, null, null];
      let selectedColour = '';
      $$('[data-option-index]', form).forEach((fs) => {
        const i = parseInt(fs.dataset.optionIndex, 10);
        const checked = fs.querySelector('input:checked');
        if (checked) {
          opts[i] = checked.value;
          if (fs.dataset.optionName === 'colour' || fs.dataset.optionName === 'color') {
            selectedColour = checked.value;
          }
          fs.querySelector('[data-selected-value]')?.replaceChildren(document.createTextNode(checked.value));
        }
      });
      filterGalleryByColour(selectedColour);
      const want = opts.filter(Boolean).join('|');
      let match;
      Array.from(select.options).forEach((o) => {
        if (o.dataset.options && (o.dataset.options.split('|').filter(Boolean).join('|') === want)) match = o;
      });
      if (match) {
        select.value = match.value;
        const price = parseInt(match.dataset.price, 10);
        const avail = match.dataset.available === 'true';
        const lbl = form.querySelector('[data-add-label]');
        const px = form.querySelector('[data-add-price]');
        const atc = form.querySelector('[data-add-to-cart]');
        const buyAvail = form.querySelector('[data-buy-available]');
        const buySold = form.querySelector('[data-buy-soldout]');
        if (lbl) lbl.textContent = avail ? 'Add to cart' : 'Sold out';
        if (px) px.textContent = avail ? '· ' + money(price) : '';
        if (atc) atc.disabled = !avail;
        if (buyAvail) buyAvail.hidden = !avail;
        if (buySold) buySold.hidden = avail;
        // Update URL ?variant=
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        history.replaceState({}, '', url);
      }
    };
    optionInputs.forEach((i) => i.addEventListener('change', updateFromSelections));
    updateFromSelections();

    const sizeGuide = $('[data-size-guide]', pdp);
    const sizeGuideTrigger = $('[data-open-modal="SizeGuide"]', pdp);
    sizeGuideTrigger?.addEventListener('click', () => sizeGuide?.showModal());
    $('[data-size-guide-close]', sizeGuide)?.addEventListener('click', () => sizeGuide.close());
    sizeGuide?.addEventListener('click', (e) => {
      if (e.target === sizeGuide) sizeGuide.close();
    });
    sizeGuide?.addEventListener('close', () => sizeGuideTrigger?.focus());

    /* Add to cart via fetch */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (form.dataset.oneOfOne === 'true') {
        const quantity = form.querySelector('[name="quantity"]');
        if (quantity) quantity.value = '1';
      }
      const btn = form.querySelector('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      const lbl = btn.querySelector('[data-add-label]');
      const orig = lbl?.textContent || 'Add to cart';
      lbl && (lbl.textContent = 'Adding…');
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('add-failed');
        await refreshCart({ open: true });
        toast('Added to your bag');
      } catch (err) {
        toast('Could not add to bag');
      } finally {
        lbl && (lbl.textContent = orig);
      }
    });
  })();

  /* -------------------------------------------------------------------
     Cart: update quantity / remove / refresh drawer & page
  ------------------------------------------------------------------- */
  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function fetchSection(section) {
    const r = await fetch(`/?section_id=${section}`, { credentials: 'include' });
    return r.text();
  }

  async function refreshCart({ open = false } = {}) {
    const cart = await fetchCart();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = money(cart.total_price));

    // Refresh the drawer markup
    try {
      const html = await fetchSection('cart-drawer');
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const fresh = tmp.querySelector('#DrawerCart');
      const live = $('#DrawerCart');
      if (fresh && live) {
        const wasOpen = live.hasAttribute('data-open');
        live.innerHTML = fresh.innerHTML;
        if (wasOpen || open) {
          // Drawer becomes visible
          live.hidden = false;
          requestAnimationFrame(() => live.setAttribute('data-open', ''));
          document.body.style.overflow = 'hidden';
        }
      }
    } catch (e) {}

    // Refresh cart page items list if present
    if (document.querySelector('.cart-page')) {
      try {
        const html = await fetchSection('main-cart');
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const fresh = tmp.querySelector('.cart-page');
        const live = document.querySelector('.cart-page');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      } catch (e) {}
    }
  }

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('.qty[data-qty] .qty__input');
    if (!input) return;
    const wrap = input.closest('.qty');
    const key = wrap.dataset.key;
    if (!key) return;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) || 0 })
      });
      await refreshCart();
    } catch (e) {}
  });

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    e.preventDefault();
    const li = rm.closest('[data-key]');
    const key = li?.dataset.key;
    if (!key) return;
    li.style.opacity = '.4';
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshCart();
    } catch (e) { li.style.opacity = ''; }
  });

  /* -------------------------------------------------------------------
     Cart note debounce
  ------------------------------------------------------------------- */
  document.addEventListener('input', (e) => {
    const ta = e.target.closest('.cart-note textarea');
    if (!ta) return;
    clearTimeout(ta._h);
    ta._h = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: ta.value })
      });
    }, 600);
  });

  /* -------------------------------------------------------------------
     Mobile collection filters
  ------------------------------------------------------------------- */
  (() => {
    const details = $('.plp__filters');
    if (!details) return;
    const mobile = matchMedia('(max-width: 600px)');
    const unlock = () => { document.body.style.overflow = ''; };
    details.addEventListener('toggle', () => {
      if (!mobile.matches) return unlock();
      document.body.style.overflow = details.open ? 'hidden' : '';
      if (details.open) $('[data-filter-close]', details)?.focus({ preventScroll: true });
    });
    $('[data-filter-close]', details)?.addEventListener('click', () => {
      details.open = false;
      details.querySelector('summary')?.focus({ preventScroll: true });
    });
    mobile.addEventListener('change', () => {
      if (!mobile.matches) {
        details.open = false;
        unlock();
      }
    });
  })();

  /* -------------------------------------------------------------------
     PLP sort
  ------------------------------------------------------------------- */
  $$('[data-sort]').forEach((s) => {
    s.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      window.location.href = url.toString();
    });
  });

  /* -------------------------------------------------------------------
     Address delete confirm + edit toggle (customer addresses)
  ------------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const del = e.target.closest('[data-delete]');
    if (del) {
      const msg = del.dataset.confirmMessage || 'Are you sure?';
      if (!confirm(msg)) e.preventDefault();
      return;
    }
  });

  /* -------------------------------------------------------------------
     Footer accordion: collapsed on mobile, open on desktop
  ------------------------------------------------------------------- */
  (() => {
    const items = $$('[data-footer-accordion]');
    if (!items.length) return;
    const mq = matchMedia('(max-width: 749px)');
    let lastIsMobile = null;
    const sync = () => {
      const isMobile = mq.matches;
      if (isMobile === lastIsMobile) return;
      lastIsMobile = isMobile;
      items.forEach((el) => { el.open = !isMobile; });
    };
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    sync();
  })();

  /* Native lazy loading + browser default = best CLS. No JS fade needed. */
})();
